export default function(nga, admin) {
    let entity = admin.getEntity('game')
        .label('Game');

    entity.listView()
        .fields([
            nga.field('id').label('ID').isDetailLink(true).detailLinkRoute('show'),
            nga.field('name').label('NAME').isDetailLink(true).detailLinkRoute('show'),
            nga.field('ability.name').label('ABILITY')
                .label('ABILITY').isDetailLink(true).detailLinkRoute('show'),
            nga.field('weight').label('WEIGHT').isDetailLink(true).detailLinkRoute('show'),
            nga.field('gold', 'boolean').label('VISIBLE_AUTOMATIC'),
            nga.field('age')
        ])
        .sortDir('asc')
        .url('games');

    entity.showView().fields([
        nga.field('id').label('ID'),
        nga.field('name').label('NAME'),
        nga.field('description').label('DESCRIPTION'),
        nga.field('weight').label('WEIGHT'),
        nga.field('gold', 'boolean').label('VISIBLE_AUTOMATIC'),
        nga.field('age'),
        nga.field('ability.name').label('ABILITY')
            .label('ABILITY'),
        nga.field('variables', 'referenced_list').label('VARIABLES')
            .targetEntity(nga.entity('config').url('configs'))
            .targetReferenceField('game')
            .targetFields([
                nga.field('id').label('ID').isDetailLink(false),
                nga.field('variable').label('VARIABLE')
                    .map(function truncate(value, entry) {
                        return entry['variable.name'];
                    })
            ]),
        nga.field('').label('')
            .template('<ma-create-button entity-name="config" size="sm" label="Add related variable" default-values="{ \'game.id\': entry.values.id }" class="pull-right"> </ma-create-button><ma-filtered-list-button label="See all related variable" entity-name="config" filter="{  game: entry.values.id }" size="sm" class="pull-right">')
    ])
        .actions([`<a class="btn btn-default" ui-sref="gameTest({id: entry.values.id})"><span class="glyphicon glyphicon-wrench" aria-hidden="true"></span>&nbsp;<span class="hidden-xs ng-scope" translate="Test">Test</span></a>`, 'list', 'edit', 'delete']);

    entity.creationView().fields([
        nga.field('name').label('NAME'),
        nga.field('description').label('DESCRIPTION'),
        nga.field('weight').label('WEIGHT'),
        nga.field('age', 'number'),
        nga.field('gold', 'boolean').label('VISIBLE_AUTOMATIC')
            .template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>'),
        nga.field('ability.id', 'reference')
            .label('ABILITY')
            .map(function truncate(value, entry) {
                return entry['ability.id'];
            })
            .targetEntity(nga.entity('ability').url('abilities'))
            .targetField(nga.field('name')),
    ]);

    entity.editionView().fields(
        entity.creationView().fields()
    );
    entity.deletionView();

    return entity;
}



/** WEBPACK FOOTER **
 ** ./js/entities/game/config.js
 **/